import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "23",
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_7688_19754)" }, [
      _createElementVNode("path", {
        d: "M11 0.513672C4.92422 0.513672 0 5.43789 0 11.5137C0 16.1758 2.90039 20.1547 6.99102 21.7574C6.89648 20.8852 6.80625 19.5531 7.02969 18.6035C7.23164 17.7441 8.31875 13.1379 8.31875 13.1379C8.31875 13.1379 7.98789 12.4805 7.98789 11.5051C7.98789 9.97539 8.87305 8.83242 9.97734 8.83242C10.9141 8.83242 11.3695 9.53711 11.3695 10.3836C11.3695 11.3289 10.768 12.7383 10.4586 14.0445C10.2008 15.1402 11.0086 16.034 12.0871 16.034C14.0422 16.034 15.5461 13.9715 15.5461 10.998C15.5461 8.36406 13.6555 6.5207 10.9527 6.5207C7.82461 6.5207 5.98555 8.8668 5.98555 11.2945C5.98555 12.2398 6.35078 13.2539 6.80625 13.8039C6.89648 13.9113 6.90937 14.0102 6.88359 14.1176C6.80195 14.4656 6.61289 15.2133 6.57852 15.3637C6.53125 15.5656 6.41953 15.6086 6.20898 15.5098C4.83398 14.8695 3.97461 12.8629 3.97461 11.2473C3.97461 7.77539 6.49688 4.59141 11.2406 4.59141C15.0563 4.59141 18.0211 7.31133 18.0211 10.9465C18.0211 14.7363 15.632 17.7871 12.3148 17.7871C11.202 17.7871 10.1535 17.207 9.79258 16.5238C9.79258 16.5238 9.24258 18.625 9.10938 19.1406C8.86016 20.0945 8.18984 21.2934 7.74297 22.0238C8.77422 22.3418 9.86563 22.5137 11 22.5137C17.0758 22.5137 22 17.5895 22 11.5137C22 5.43789 17.0758 0.513672 11 0.513672Z",
        fill: "white"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_7688_19754" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          fill: "white",
          transform: "translate(0 0.513672)"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }